import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap');

  .blog2-root {
    font-family: 'DM Sans', sans-serif;
    background: #FAFAF8;
    min-height: 100vh;
    color: #1a1a18;
  }

  .blog2-hero {
    background: #0f2318;
    padding: 80px 24px 64px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .blog2-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 60% 0%, rgba(29,158,117,0.18) 0%, transparent 65%),
                radial-gradient(ellipse at 20% 100%, rgba(29,158,117,0.10) 0%, transparent 60%);
  }

  .blog2-tag {
    display: inline-block;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #5DCAA5;
    background: rgba(93,202,165,0.12);
    border: 1px solid rgba(93,202,165,0.25);
    border-radius: 100px;
    padding: 5px 14px;
    margin-bottom: 28px;
    position: relative;
  }

  .blog2-hero-title {
    font-family: 'Lora', Georgia, serif;
    font-size: clamp(28px, 5vw, 52px);
    font-weight: 600;
    line-height: 1.2;
    color: #f5f3ee;
    max-width: 760px;
    margin: 0 auto 20px;
    position: relative;
  }

  .blog2-hero-meta {
    font-size: 13px;
    color: rgba(245,243,238,0.45);
    position: relative;
    letter-spacing: 0.02em;
  }

  .blog2-hero-meta span {
    margin: 0 8px;
  }

  .blog2-body {
    max-width: 720px;
    margin: 0 auto;
    padding: 64px 24px 96px;
  }

  .blog2-intro {
    font-size: 19px;
    line-height: 1.75;
    color: #2a2a26;
    font-weight: 300;
    margin-bottom: 48px;
    padding-bottom: 48px;
    border-bottom: 1px solid #e8e6e0;
  }

  .blog2-section {
    margin-bottom: 52px;
    opacity: 0;
    transform: translateY(18px);
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  .blog2-section.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .blog2-h2 {
    font-family: 'Lora', Georgia, serif;
    font-size: 26px;
    font-weight: 600;
    color: #0f2318;
    margin: 0 0 18px;
    line-height: 1.3;
  }

  .blog2-p {
    font-size: 16px;
    line-height: 1.8;
    color: #3a3a36;
    margin: 0 0 16px;
    font-weight: 300;
  }

  .step-block {
    border-left: 3px solid #1D9E75;
    padding: 20px 24px;
    margin: 20px 0;
    background: #fff;
    border-radius: 0 12px 12px 0;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .step-number {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #1D9E75;
    margin-bottom: 6px;
  }

  .step-title {
    font-size: 17px;
    font-weight: 500;
    color: #1a1a18;
    margin-bottom: 8px;
  }

  .step-desc {
    font-size: 15px;
    line-height: 1.75;
    color: #4a4a46;
    font-weight: 300;
    margin: 0;
  }

  .blog2-callout {
    background: #0f2318;
    border-radius: 12px;
    padding: 28px 32px;
    margin: 40px 0;
    position: relative;
    overflow: hidden;
  }

  .blog2-callout::before {
    content: '';
    position: absolute;
    top: 0; right: 0;
    width: 180px; height: 180px;
    background: radial-gradient(circle, rgba(93,202,165,0.15) 0%, transparent 70%);
    border-radius: 50%;
    transform: translate(40%, -40%);
  }

  .blog2-callout-text {
    font-family: 'Lora', Georgia, serif;
    font-size: 20px;
    font-style: italic;
    color: #f5f3ee;
    line-height: 1.6;
    margin: 0;
    position: relative;
  }

  .blog2-callout-text em {
    color: #5DCAA5;
    font-style: normal;
  }

  .checklist {
    list-style: none;
    padding: 0;
    margin: 16px 0 0;
  }

  .checklist li {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 10px 0;
    border-bottom: 1px solid #e8e6e0;
    font-size: 15px;
    color: #3a3a36;
    line-height: 1.6;
    font-weight: 300;
  }

  .checklist li:last-child {
    border-bottom: none;
  }

  .check-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(29,158,117,0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .check-icon svg {
    width: 11px;
    height: 11px;
  }

  .divider {
    border: none;
    border-top: 1px solid #e8e6e0;
    margin: 48px 0;
  }

  .blog2-cta {
    background: #0f2318;
    border-radius: 16px;
    padding: 48px 40px;
    text-align: center;
    margin-top: 64px;
    position: relative;
    overflow: hidden;
  }

  .blog2-cta::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 50% 100%, rgba(93,202,165,0.2) 0%, transparent 60%);
  }

  .blog2-cta-title {
    font-family: 'Lora', Georgia, serif;
    font-size: 28px;
    font-weight: 600;
    color: #f5f3ee;
    margin: 0 0 12px;
    position: relative;
    z-index: 1;
  }

  .blog2-cta-sub {
    font-size: 15px;
    color: rgba(245,243,238,0.55);
    margin: 0 0 28px;
    position: relative;
    z-index: 1;
  }

  .blog2-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #1D9E75;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    padding: 14px 28px;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    position: relative;
    z-index: 1;
    transition: background 0.2s, transform 0.15s;
    text-decoration: none;
  }

  .blog2-cta-btn:hover {
    background: #5DCAA5;
    transform: translateY(-1px);
  }
`;

const steps = [
  {
    n: "Step 1",
    title: "Choose the right chatbot tool",
    desc: "Not all chatbot tools are built for small businesses. Look for one that requires no coding, sets up in minutes, and handles real conversations — not just rigid scripts. Wispy AI was built specifically for this.",
  },
  {
    n: "Step 2",
    title: "Create your account and set up your bot",
    desc: "Sign up and give your chatbot a name and personality. Then train it on your business — paste in your FAQs, describe your services, add your opening hours and pricing. The more information you give it, the better it performs.",
  },
  {
    n: "Step 3",
    title: "Copy your embed code",
    desc: "Once your bot is configured, you'll get a single line of JavaScript code. It looks something like this: <script src='https://cdn.wispy.ai/widget.js' data-bot-id='your_id'></script>. Copy it — you'll need it in the next step.",
  },
  {
    n: "Step 4",
    title: "Paste the code into your website",
    desc: "Open your website editor and paste the code just before the closing </body> tag. This works on any platform — WordPress, Webflow, Wix, Squarespace, Shopify, or a custom-built site. If you use WordPress, you can paste it under Appearance → Theme Editor → footer.php.",
  },
  {
    n: "Step 5",
    title: "Test it and go live",
    desc: "Visit your website and look for the chat bubble in the bottom corner. Click it and send a test message. Make sure it answers correctly. Adjust any responses that don't sound right — then you're live.",
  },
];

export default function WispyBlogPost2() {
  const [visible, setVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting)
            setVisible((v) => ({ ...v, [e.target.id]: true }));
        });
      },
      { threshold: 0.12 },
    );
    document
      .querySelectorAll(".blog2-section")
      .forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          How to Add a Chatbot to Your Website (Step-by-Step Guide) | Wispy AI
        </title>
        <meta
          name="description"
          content="Learn how to add an AI chatbot to your website in under 10 minutes — no coding required. Works on WordPress, Webflow, Wix, Shopify, and more."
        />
        <meta
          property="og:title"
          content="How to Add a Chatbot to Your Website | Wispy AI"
        />
        <meta
          property="og:description"
          content="Step-by-step guide to adding an AI chatbot to any website in minutes. No coding required."
        />
        <meta
          property="og:url"
          content="https://wispyaii.com/blog/how-to-add-chatbot-to-website"
        />
        <meta property="og:type" content="article" />
      </Helmet>
      <style>{styles}</style>
      <article className="blog2-root">
        <header className="blog2-hero">
          <div className="blog2-tag">Beginner Guide · Website Tips · 2026</div>
          <h1 className="blog2-hero-title">
            How to Add a Chatbot to Your Website (Step-by-Step Guide)
          </h1>
          <p className="blog2-hero-meta">
            <span>6 min read</span>·<span>No coding required</span>·
            <span>Works on any platform</span>
          </p>
        </header>

        <div className="blog2-body">
          <p className="blog2-intro">
            Adding a chatbot to your website used to require a developer, weeks
            of setup, and a large budget. Not anymore. Today any small business
            owner can add a fully functional AI chatbot in under 10 minutes — no
            coding, no technical knowledge required. This guide shows you
            exactly how.
          </p>

          {/* Section 1 */}
          <section
            id="why"
            className={`blog2-section${visible["why"] ? " visible" : ""}`}
          >
            <h2 className="blog2-h2">Why Add a Chatbot to Your Website?</h2>
            <p className="blog2-p">
              Most small business websites have the same problem: visitors
              arrive, look around, can't find the answer they need, and leave.
              No sale. No lead. No way to follow up.
            </p>
            <p className="blog2-p">
              A chatbot fixes this by being available the moment a visitor has a
              question — at any hour, on any day. It answers instantly, collects
              their contact details, and can even book an appointment, all
              without you lifting a finger.
            </p>
            <div className="blog2-callout">
              <p className="blog2-callout-text">
                Businesses that respond to enquiries within <em>5 minutes</em>{" "}
                are 9x more likely to convert a lead than those who respond
                after 30 minutes. A chatbot responds in seconds, every time.
              </p>
            </div>
          </section>

          <hr className="divider" />

          {/* Section 2 */}
          <section
            id="before"
            className={`blog2-section${visible["before"] ? " visible" : ""}`}
          >
            <h2 className="blog2-h2">What You Need Before You Start</h2>
            <p className="blog2-p">
              You do not need any technical skills. You just need:
            </p>
            <ul className="checklist">
              {[
                "A website on any platform (WordPress, Webflow, Wix, Shopify, Squarespace, or custom)",
                "Access to edit your website's code or settings — even basic access is enough",
                "A chatbot account — you can sign up for Wispy AI free in under 2 minutes",
                "Basic information about your business — services, pricing, FAQs, opening hours",
              ].map((item) => (
                <li key={item}>
                  <span className="check-icon">
                    <svg viewBox="0 0 12 12" fill="none">
                      <path
                        d="M2 6l3 3 5-5"
                        stroke="#1D9E75"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <hr className="divider" />

          {/* Section 3 - Steps */}
          <section
            id="steps"
            className={`blog2-section${visible["steps"] ? " visible" : ""}`}
          >
            <h2 className="blog2-h2">
              How to Add a Chatbot to Your Website: 5 Steps
            </h2>
            <p className="blog2-p">
              Follow these steps in order. The whole process takes less than 10
              minutes.
            </p>
            {steps.map((step) => (
              <div className="step-block" key={step.n}>
                <div className="step-number">{step.n}</div>
                <div className="step-title">{step.title}</div>
                <p className="step-desc">{step.desc}</p>
              </div>
            ))}
          </section>

          <hr className="divider" />

          {/* Section 4 */}
          <section
            id="platforms"
            className={`blog2-section${visible["platforms"] ? " visible" : ""}`}
          >
            <h2 className="blog2-h2">Platform-Specific Instructions</h2>
            <p className="blog2-p">
              Here is where to paste the embed code on the most common
              platforms:
            </p>
            <ul className="checklist">
              {[
                [
                  "WordPress",
                  "Appearance → Theme Editor → footer.php, paste before </body>",
                ],
                ["Webflow", "Project Settings → Custom Code → Footer Code"],
                ["Wix", "Settings → Custom Code → Add Code → Body — end"],
                [
                  "Shopify",
                  "Online Store → Themes → Edit Code → theme.liquid, before </body>",
                ],
                [
                  "Squarespace",
                  "Settings → Advanced → Code Injection → Footer",
                ],
                [
                  "Custom HTML site",
                  "Open your index.html and paste before </body>",
                ],
              ].map(([platform, instruction]) => (
                <li key={platform}>
                  <span className="check-icon">
                    <svg viewBox="0 0 12 12" fill="none">
                      <path
                        d="M2 6l3 3 5-5"
                        stroke="#1D9E75"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>
                    <strong style={{ fontWeight: 500, color: "#1a1a18" }}>
                      {platform}:
                    </strong>{" "}
                    {instruction}
                  </span>
                </li>
              ))}
            </ul>
          </section>

          <hr className="divider" />

          {/* Section 5 */}
          <section
            id="tips"
            className={`blog2-section${visible["tips"] ? " visible" : ""}`}
          >
            <h2 className="blog2-h2">
              Tips to Get the Most Out of Your Chatbot
            </h2>
            <p className="blog2-p">
              Once your chatbot is live, these small adjustments will
              significantly improve its performance:
            </p>
            <ul className="checklist">
              {[
                "Train it on your most frequently asked questions first — these are what most visitors will ask",
                "Set a friendly opening message that matches your brand tone — first impressions matter",
                "Enable lead capture so every conversation collects the visitor's name and email",
                "Check your chat history weekly and update answers that aren't performing well",
                "Add appointment booking if your business runs on scheduled calls or visits",
              ].map((tip) => (
                <li key={tip}>
                  <span className="check-icon">
                    <svg viewBox="0 0 12 12" fill="none">
                      <path
                        d="M2 6l3 3 5-5"
                        stroke="#1D9E75"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </section>

          <hr className="divider" />

          {/* Section 6 */}
          <section
            id="common-questions"
            className={`blog2-section${visible["common-questions"] ? " visible" : ""}`}
          >
            <h2 className="blog2-h2">Common Questions</h2>
            {[
              [
                "Will it slow down my website?",
                "No. The embed code loads asynchronously, which means it does not affect your page speed at all.",
              ],
              [
                "Can I customise how it looks?",
                "Yes. You can change the colour, name, avatar, and opening message to match your brand.",
              ],
              [
                "What if a visitor asks something the bot doesn't know?",
                "You can configure a fallback message that offers to connect them with you directly, so no lead is ever lost.",
              ],
              [
                "Does it work on mobile?",
                "Yes. The chat widget is fully responsive and works on all screen sizes.",
              ],
            ].map(([q, a]) => (
              <div
                key={q}
                style={{
                  borderLeft: "3px solid #5DCAA5",
                  paddingLeft: 20,
                  marginBottom: 24,
                }}
              >
                <p
                  style={{
                    fontWeight: 500,
                    color: "#1a1a18",
                    fontSize: 15,
                    marginBottom: 6,
                  }}
                >
                  {q}
                </p>
                <p
                  style={{
                    color: "#5a5a56",
                    fontSize: 15,
                    lineHeight: 1.7,
                    fontWeight: 300,
                    margin: 0,
                  }}
                >
                  {a}
                </p>
              </div>
            ))}
          </section>

          {/* CTA */}
          <section
            id="cta"
            className={`blog2-section${visible["cta"] ? " visible" : ""}`}
          >
            <div className="blog2-cta">
              <p className="blog2-cta-title">
                Ready to add a chatbot to your website?
              </p>
              <p className="blog2-cta-sub">
                Wispy AI sets up in minutes — no coding, no credit card, no
                commitment.
              </p>
              <a href="https://wispyaii.com/register" className="blog2-cta-btn">
                Try Wispy AI free
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M3 8h10M9 4l4 4-4 4"
                    stroke="#fff"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </section>
        </div>
      </article>
    </>
  );
}
